import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { title: '首页', parent:'/' },
      component: (resolve) => require(['@/pages/home'], resolve)
    },
    {
      path: '/hotDynamic',
      name: 'hotDynamic',
      meta: { title: '热点动态', parent:'/hotDynamic' },
      component: (resolve) => require(['@/pages/hotDynamic'], resolve),
    },
    
    {
      path: '/hotDynamicDetail',
      name: 'hotDynamicDetail',
      meta: { title: '热点动态', parent:'/hotDynamic' },
      component: (resolve) => require(['@/pages/hotDynamicDetail'], resolve)
    },
    {
      path: '/expertsLibrary',
      name: 'expertsLibrary',
      meta: { title: '专家智库', parent:'/expertsLibrary' },
      component: (resolve) => require(['@/pages/expertsLibrary'], resolve)
    },
    {
      path: '/businessCollege',
      name: 'businessCollege',
      meta: { title: '商学院', parent:'/businessCollege' },
      component: (resolve) => require(['@/pages/businessCollege'], resolve)
    },
    {
      path: '/courseList',
      name: 'courseList',
      meta: { title: '课程列表', parent:'' },
      component: (resolve) => require(['@/pages/courseList'], resolve)
    },
    {
      path: '/courseDetail',
      name: 'courseDetail',
      meta: { title: '课程详情', parent:'' },
      component: (resolve) => require(['@/pages/courseDetail'], resolve)
    },
    {
      path: '/activityList',
      name: 'activityList',
      meta: { title: '活动列表', parent:'' },
      component: (resolve) => require(['@/pages/activityList'], resolve)
    },
    {
      path: '/activityDetail',
      name: 'activityDetail',
      meta: { title: '活动详情', parent:'' },
      component: (resolve) => require(['@/pages/activityDetail'], resolve)
    },
    {
      path: '/studentCollege',
      name: 'studentCollege',
      meta: { title: '小院士', parent:'/studentCollege' },
      component: (resolve) => require(['@/pages/studentCollege'], resolve)
    },
    {
      path: '/adultEducation',
      name: 'adultEducation',
      meta: { title: '职业技术培训', parent:'/adultEducation' },
      component: (resolve) => require(['@/pages/adultEducation'], resolve)
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: { title: '关于我们', parent:'/aboutUs' },
      component: (resolve) => require(['@/pages/aboutUs'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js